/** Längste Kante nach dem Verkleinern. Reicht für eine Erinnerungsstütze im Laden. */
const MAX_KANTE = 1200;
const QUALITAET = 0.82;

/**
 * Verkleinert ein Bild im Browser, bevor es die Datenleitung sieht.
 *
 * Ein Handyfoto hat schnell fünf Megabyte. Im Laden, bei einem Balken Empfang,
 * ist das der Unterschied zwischen "ist da" und "lädt noch". Gedreht wird über
 * die Bitmap-Schnittstelle, die EXIF-Ausrichtung berücksichtigt.
 */
export async function verkleinern(file: File | Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });

  const faktor = Math.min(1, MAX_KANTE / Math.max(bitmap.width, bitmap.height));
  const breite = Math.round(bitmap.width * faktor);
  const hoehe = Math.round(bitmap.height * faktor);

  const canvas = document.createElement("canvas");
  canvas.width = breite;
  canvas.height = hoehe;

  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Kein Zeichenbereich verfügbar");
  ctx.drawImage(bitmap, 0, 0, breite, hoehe);
  bitmap.close();

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, "image/jpeg", QUALITAET);
  });
  if (!blob) throw new Error("Bild konnte nicht umgewandelt werden");
  return blob;
}

/**
 * Bild als Data-URL, wie sie die Modelle erwarten.
 *
 * FileReader statt einer eigenen Base64-Runde: Der Browser macht das im
 * Hintergrund und ohne den Umweg über einen Zwischenpuffer, der bei einem
 * Fünf-Megabyte-Foto auf einem älteren Telefon spürbar wäre.
 */
export function alsDatenUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const leser = new FileReader();
    leser.onload = () => {
      resolve(String(leser.result));
    };
    leser.onerror = () => {
      reject(new Error("Bild konnte nicht gelesen werden"));
    };
    leser.readAsDataURL(blob);
  });
}
